import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import Message from "./Message";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import "./Category.css";
import { listCategory } from "../actions/categoryActions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <MdNavigateNext
      className={className}
      style={{
        color: "gray",
        fontSize: "45px",
        height: "55px",
        width: "55px",
        paddingLeft: "20px",
      }}
      onClick={onClick}
    ></MdNavigateNext>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <MdNavigateBefore
      className={className}
      style={{
        color: "gray",
        fontSize: "45px",
        height: "55px",
        width: "55px",
        paddingRight: "20px",
      }}
      onClick={onClick}
    ></MdNavigateBefore>
  );
}

export default function Category() {
  const dispatch = useDispatch();

  const { loading, error, categories } = useSelector(
    (state) => state.categoryList
  );

  useEffect(() => {
    dispatch(listCategory());
  }, [dispatch]);

  const settings = {
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    // <div className={`bg-[#F3F3FD]`}>
    <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8`}>
      <p className="text-center text-xl font-semibold py-8">SHOP BY CATEGORY</p>
      {loading ? (
        <div></div>
      ) : error ? (
        <Message type="error">{error}</Message>
      ) : (
        <Slider
          // prevArrow={<SamplePrevArrow />}
          // nextArrow={<SampleNextArrow />}
          {...settings}
        >
          {categories.map((catObj, i) => (
            <div className={`cursor-pointer px-2`} key={i}>
              <RouterLink
                className="block"
                to={`/product?categories=${catObj._id}&menu=${catObj.name}`}
              >
                <img
                  src={catObj.image}
                  alt={catObj.name}
                  loading="lazy"
                  className="mx-auto ease-in transition hover:scale-105 md:w-[80%] h-[100px] md:h-auto object-contain"
                />
              </RouterLink>
              <h1 className="text-[10px] md:text-[14px] font-[600] text-black text-center uppercase p-3">
                {catObj.name}
              </h1>
            </div>
          ))}
        </Slider>
      )}
    </div>
    // </div>
  );
}
